module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-400-[23]144.cb73d02.woff2";